<template lang="html">
  <div v-if="items.length > 0" class="slider-wrapper">
    <div class="slider-title">
      <div class="category-name">
        <!-- {{this.category}} -->
        {{ getCategoryName(this.category) }}
      </div>
      <div class="line"></div>
      <div class="navigation-btn-wrapper">
        <div @click="navigate('left')" class="btn">
          <img
            src="@/assets/newImges/icons/sliderBtnLeft.svg"
            alt="slider btn left"
          />
        </div>
        <div @click="navigate('right')" class="btn">
          <img
            src="@/assets/newImges/icons/sliderBtnRight.svg"
            alt="slider btn right"
          />
        </div>
      </div>
    </div>
    <div ref="sliderWrapper" class="slider-content">
      <item :itemData="item" v-for="item in items" :key="item.id" />
    </div>
  </div>
</template>

<script>
import { api } from "@/api";
import Item from "@/components/item/item.vue";
import eventBus from "@/shared/eventBus.js";
export default {
  name: "slider",
  props: {
    category: {
      required: true,
      type: String,
      default: "new"
    },
    group: {
      type: Number
    },
    similar: {
      required: false,
      type: Number
    },
    user: {
      required: false,
      type: Number
    }
  },
  components: {
    Item
  },
  data() {
    return {
      items: [],
      // categoryTranslation: this.$i18n.t(this.category)
      categoryTranslation: this.category
    };
  },
  mounted() {
    this.fetchItems();
    eventBus.$on("refresh", () => {
      this.fetchItems();
    });
  },
  activated() {
    this.fetchItems();
    eventBus.$on("refresh", () => {
      this.fetchItems();
    });
  },
  methods: {
    fetchItems() {
      if (this.similar) {
        api
          .getSimilarProducts(this.similar)
          .then(res => {
            this.items = res.data.data;
          })
          .catch(e => {
            console.log(e);
          });
        return;
      }
      if (this.user) {
        api
          .getUserProducts(this.user)
          .then(res => {
            this.items = res.data.data;
          })
          .catch(e => {
            console.log(e);
          });
        return;
      }
      if (this.group === 1) {
        api
          .getGroupNew()
          .then(res => {
            this.items = res.data.data;
          })
          .catch(e => {
            console.log(e);
          });
      } else if (this.group === 2) {
        api
          .getGroupPopular()
          .then(res => {
            this.items = res.data.data;
          })
          .catch(e => {
            console.log(e);
          });
      } else {
        api
          .getGroupProducts(this.group)
          .then(res => {
            this.items = res.data.data;
          })
          .catch(e => {
            console.log(e);
          });
      }
    },
    navigate(direction) {
      let el = this.$refs.sliderWrapper;
      let itemWidth = 282;
      let itemsShown = Math.ceil(el.clientWidth / itemWidth);
      if (direction === "right") {
        el.scrollLeft += itemWidth * (itemsShown - 1);
      } else {
        el.scrollLeft -= itemWidth * (itemsShown - 1);
      }
    },
    getCategoryName(name) {
      // if (name === 'Najtraženije' || name === 'Najnovije') {
      //   return this.$t('home.' + name)
      // }
      return name;
    }
  },
  watch: {
    user: {
      handler: function() {
        this.fetchItems();
      },
      deep: true,
      immediate: true
    }
  },
  destroyed() {
    eventBus.$off("refresh");
  }
};
</script>

<style lang="scss" scoped>
.slider-wrapper {
  font-family: Outfit;
  width: 100%;
  margin-bottom: 50px;
  overflow: hidden;

  .slider-title {
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-bottom: 30px;

    .category-name {
      font-weight: 500;
      font-style: Medium;
      font-size: 36px;
      line-height: 100%;
      letter-spacing: 0%;
      color: $blue-1000;

      // text-transform: uppercase;
    }
    .line {
      flex-grow: 1;
      height: 1px;
      // background-color: rgba(0, 0, 0, 0.15);
      margin: 0 22px;
    }
    .navigation-btn-wrapper {
      display: flex;
      flex-direction: row;
      align-items: center;

      .btn {
        border: 1px solid $gray-blue-700; // $gray-blue-700
        box-shadow: 0px 2px 5px #0000000f;
        border-radius: 10px;
        height: 60px;
        width: 60px;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        background: $gray-100;
        padding: 0px;

        img {
          // filter: brightness(5);
        }
      }
      .btn:active {
        box-shadow: 0px 3px 6px #00000000;
      }
      .btn:first-child {
        margin-right: 20px;
      }
    }
  }
  .slider-content {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: flex-start;
    overflow: auto;
    scroll-behavior: smooth;
    -ms-overflow-style: none; /* IE and Edge */
    scrollbar-width: none;
  }
  .slider-content::-webkit-scrollbar {
    display: none;
  }
}
.sliders-wrapper .slider-wrapper {
  // background: white;
  // padding: 20px;
  box-sizing: border-box;
}

@media only screen and (max-width: 768px) {
  .slider-wrapper {
    .slider-title {
      display: flex;
      flex-direction: row;
      align-items: center;
      margin-bottom: 30px;

      .category-name {
        font-size: 20px;
        line-height: 100%;
      }
      .line {
        flex-grow: 1;
        height: 1px;
        // background-color: rgba(0, 0, 0, 0.15);
        margin: 0 22px;
      }
      .navigation-btn-wrapper {
        display: flex;
        flex-direction: row;
        align-items: center;

        .btn {
          border: 1px solid $gray-blue-700; // $gray-blue-700
          box-shadow: 0px 2px 5px #0000000f;
          border-radius: 10px;
          height: 40px;
          width: 40px;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          background: $gray-100;
          padding: 0px;

          img {
            // filter: brightness(5);
          }
        }
        .btn:active {
          box-shadow: 0px 3px 6px #00000000;
        }
        .btn:first-child {
          margin-right: 10px;
        }
      }
    }
    .slider-content {
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      align-items: flex-start;
      overflow: auto;
      scroll-behavior: smooth;
      -ms-overflow-style: none; /* IE and Edge */
      scrollbar-width: none;
    }
    .slider-content::-webkit-scrollbar {
      display: none;
    }
  }
}
</style>
